import { action, observable, toJS, IObservableArray, makeObservable, reaction } from 'mobx'
import { StrategyType, MessageOp, MessageUpdateOp, file, Community, FilesType, StatusType } from '../utils/types'
import { OperationType } from '../utils/operation'
import { newGuid } from '../utils/generates'
import api from '../service/api'
import userStore from './user.store'
import { addDays } from 'date-fns'
import { Message } from 'utils/models'
import messages, { MessageDetails } from './messages.store'
import { MessageTwoTone } from '@material-ui/icons'
import * as moment from 'moment'


const IMAGE_MAX_HEIGHT_AND_WIDTH = 800
const MAX_FILE_SIZE_MB = 2

export enum selectGroup {
  CULTURE = 'CULTURE',
  SECURITY = 'SECURITY',
  GENERAL = 'GENERAL',
}
enum groupNumbers {
  CULTURE = 5273,
  SECURITY = 5271,
  GENERAL = 5272,
}
export interface FilterCommunity extends Community {
  status: boolean
}
interface goNewMessage {
  guid: string
  senderId: number
  strategyType: StrategyType
  label: string
  payload: string
  files: file[] | null
  expiry: Date
  schedule: Date | null
  created: Date | null
  communities: IObservableArray<FilterCommunity>
  id: number
}
const IsJsonString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
class NewMessageStore {

  constructor() {
    makeObservable(this, {
      messageDialogOpen: observable,
      currentMessage: observable,
      openMessageDialog: action,
      closeMessageDialog: action,
      newMessage: observable,
      updateMessagePayload: action,
      updateGroupSelect: action,
      updateExpiryDate: action,
      updateScheduleDate: action,
      setFiles: action,
      setVideoFiles: action,
      clearFiles: action,
      changeCommunityStatus: action,
      changeStatusAllCommunities: action,
      addNewMessageToFeed: action,
    })

    //close dialog incase auth triggered logout
    reaction(() => (userStore.isAuth), (isAuth: boolean) => {
      if (!isAuth) {
        this.closeMessageDialog()
      }
    })
  }

  emptyNewMessage: goNewMessage = {
    guid: newGuid(),
    senderId: userStore.user?.user_id,
    strategyType: StrategyType.text,
    payload: '',
    files: null,
    expiry: addDays(new Date(), 7),
    created: null,
    schedule: null,
    communities: observable([]),
    id: 0,
    label: ''
  }
  currentMessage: Message | null = null
  messageDialogOpen: boolean = false
  newMessage: goNewMessage = this.emptyNewMessage;
  selectAll: boolean = true //not observable

  getExpiryDateByApi =  async () => {
    const res = await api.getCuttentUtc()
    
    if (!res) {
      return new Date();
    }

    return moment.utc(res).utc().toDate()
  }
  getMessagePayload = (str) => {
    try {
        return JSON.parse(str);
    } catch (e) {
        return { text: str };
    }
}

  openMessageDialog: () => void = async () => {
    this.currentMessage = null 
    const extExpiryDate = await this.getExpiryDateByApi();

    this.newMessage = this.emptyNewMessage
    this.newMessage.expiry = addDays(extExpiryDate, 7),
    this.newMessage.created = null
    this.selectAll = true
    userStore.communitiesLoading = true
    this.messageDialogOpen = true
    await userStore.initCommunities()
    this.setCommunities()
    this.newMessage.guid = newGuid()
  }

  openEditMessageDialog: (message: Message) => void = async (message: Message) => {
    this.currentMessage = message 

    const messagePayload = this.getMessagePayload(message.payload)

    this.newMessage = this.emptyNewMessage
    this.newMessage.id = message.id
    this.newMessage.senderId = userStore.user?.user_id,
    this.newMessage.expiry = message.expiry
    this.newMessage.created = message.created
    this.newMessage.payload = messagePayload.text
    this.newMessage.strategyType = message.msg_strategy
    this.newMessage.files = null

    if(this.newMessage.strategyType == StrategyType.media) {
      this.newMessage.files = messagePayload.files.map(file => ({
        type: file?.type,
        local: false,
        url: file?.fileUrl
      }))
    } 

    this.selectAll = true
    userStore.communitiesLoading = true
    this.messageDialogOpen = true
    await userStore.initCommunities()
    this.setCommunities()
    this.newMessage.guid = newGuid()
  }

  closeMessageDialog: () => void = () => {
    this.messageDialogOpen = false
  }
  setMessageLabel = (label: string) => {
    this.newMessage.label = label
  }
  updateMessagePayload = (text: string) => {
    this.newMessage.payload = text
  };
  updateGroupSelect = (groupEnum: string | null) => {
    if (groupEnum) {
      this.newMessage.label = groupEnum
      //uncheck communities that are not part of that 'group'
      if (!this.selectAll) {
        this.newMessage.communities.forEach(el => {
          if (!el.labels.includes(groupEnum)) {
            el.status = false
          }
        })
      }
    }
  };
  
  setFiles = (file: any, type: FilesType, local: boolean) => {
    this.newMessage.files = [{ url: file, type: type, local: local }]
  };
  setVideoFiles = (files: any) => {
    this.newMessage.files = files
};
  clearFiles = () => {
    this.newMessage.files = null
  };
  updateExpiryDate = (date: Date) => {
    this.newMessage.expiry = date
  };
  updateScheduleDate = (date: Date | null) => {
    this.newMessage.schedule = date
  };
  setCommunities = () => {
    this.newMessage.communities.replace(observable(userStore.communities.map(el => ({ ...el, status: true }))))
  };
  changeCommunityStatus = (id: number, status: boolean) => {
    const foundCommunity = this.newMessage.communities.find(el => el.id === id)
    if (foundCommunity) {
      foundCommunity.status = status
    }

  }
  changeStatusAllCommunities = (status: boolean) => {
    this.selectAll = status
    this.newMessage.communities.forEach((community: FilterCommunity) => {
      community.status = status
    })
  };


  createMessage = () => {
    const updatedMessage = this.newMessage && this.newMessage.id != 0
    if (updatedMessage) {
      this.updateMessageInFeed()
    } else {
      this.addNewMessageToFeed()
    }
  };


  addNewMessageToFeed = async () => {
    // if (!this.newMessage.group) {
    //   return
    // }
    this.closeMessageDialog()
    const allSelected = this.newMessage.communities.filter(el => el.status).length === userStore.communities.length
    const communities = allSelected ? [] : (this.newMessage?.communities?.filter(el => el.status).map(el => el.id) || [])
   
    try {
      let messagePayload: string = this.newMessage.payload
      
      if (this.newMessage.files) {
        if (this.newMessage.files.length == 2 && this.newMessage.files[1].type === 'VIDEO') {
          messagePayload = JSON.stringify({ 
            text: this.newMessage.payload, 
            files: [
              { fileUrl: URL.createObjectURL(this.newMessage.files[0].url), type: this.newMessage.files[0].type, },
              { fileUrl: { url: URL.createObjectURL(this.newMessage.files[1].url) }, type: this.newMessage.files[1].type, }
            ] 
          })
        
        } else if (this.newMessage.files[0].type === 'IMAGE') {
          messagePayload = JSON.stringify({ 
            text: this.newMessage.payload, 
            files: [
              { fileUrl: URL.createObjectURL(this.newMessage.files[0].url), type: this.newMessage.files[0].type, }
            ] 
          })
        } else {
          messagePayload = JSON.stringify({ 
            text: this.newMessage.payload, 
            files: [
              { fileUrl: { url: URL.createObjectURL(this.newMessage.files[0].url) }, type: this.newMessage.files[0].type, }
            ] 
          })
        }
        
        this.newMessage.strategyType = StrategyType.media
      }

      const messageOp: MessageOp = {
        op: OperationType.CREATE_MESSAGE,
        sender: userStore.user.user_id,
        type: this.newMessage.strategyType,
        payload: this.newMessage.payload,
        expiry: this.newMessage.expiry?.toISOString(),
        guid: this.newMessage.guid,
        id: 1,
        communities: communities,
        allCommunities: allSelected ? 1 : undefined,
        labels: [this.newMessage.label]
      }

      let blob = null
      
      if (this.newMessage.files) {
        if (this.newMessage.files.length == 1 && this.newMessage.files[0]?.type === FilesType.IMAGE) {
          blob = this.newMessage.files[0].url
          messageOp.files = [{ type: FilesType.IMAGE }]
          messageOp.type = StrategyType.media
        }

        else if (this.newMessage.files.length == 2 && this.newMessage.files[1]?.type === FilesType.VIDEO) {
          blob = [this.newMessage.files[0].url, this.newMessage.files[1].url]
          messageOp.type = StrategyType.media
          messageOp.files = [{ type: FilesType.IMAGE }, { type: FilesType.VIDEO }]
        }

        else if (this.newMessage.files[0]?.type === FilesType.PDF) {
          blob = this.newMessage.files[0].url
          messageOp.type = StrategyType.media
          messageOp.files = [{ type: FilesType.PDF }]
        }
      }

      this.newMessage.payload = messagePayload
      messages.updateMessage(this.createMessageFromNewMessage(StatusType.OUTGOING, communities))
     
      const createdId = await api.createMessage([messageOp], blob)
     
      if (createdId) {
        this.newMessage.id = createdId
        const messageDetailsRes = await api.getMessageDetails(createdId)
        
        await userStore.initInfo()
        if (messageDetailsRes.success) {
          const msgDetails = messageDetailsRes.data?.[0] as MessageDetails | undefined
          // messages.updateMessage(this.createMessageFromNewMessage(StatusType.SENT, message.communities, msgDetails.received, msgDetails.total))
          messages.updateMessage(this.createMessageFromNewMessage(StatusType.SENT, communities, msgDetails?.received || 0, msgDetails?.total || 0))
        }
        this.clearFiles()
      } else {
        this.clearFiles()
        throw 'fail'
      }
    } catch (e) {
      console.log('error', e)
      messages.updateMessage(this.createMessageFromNewMessage(StatusType.FAILED, communities))
    }
  }
  
  updateMessageInFeed = async () => {
    this.closeMessageDialog()
   
    let requestOp: MessageUpdateOp = {
      sender: this.newMessage.senderId,
      type: this.newMessage.strategyType,
      payload: this.newMessage.payload,
      expiry: this.newMessage.expiry?.toISOString(),
    }

    let blob = null
    const files = this.newMessage.files 

    
    if (files) {
      const isNewFile = files.filter(file => file.local).length > 0 

      if (files.length == 2 && files[1]?.type === FilesType.VIDEO) {
        requestOp.files = [{ type: FilesType.IMAGE }, { type: FilesType.VIDEO }]
        requestOp.type = StrategyType.media

        if (isNewFile) {
          blob = [files[0].url, files[1].url]
        }
      }

      else if (files[0]?.type === FilesType.IMAGE) {
        requestOp.files = [{ type: FilesType.IMAGE }]
        requestOp.type = StrategyType.media

        if (isNewFile) {
          blob = files[0].url
        }
      }

      else if (files[0]?.type === FilesType.PDF) {
        requestOp.type = StrategyType.media
        requestOp.files = [{ type: FilesType.PDF }]

        if (isNewFile) {
          blob = files[0].url
        }
      }
    } else {
      requestOp.type = StrategyType.text
    }

    const res = await api.updateMessage(this.newMessage.id, [requestOp], blob)

    if (res.statusCode === 'OK') {
      messages.getMessages()
    }

    this.clearFiles()
  }

  sendAgain = async (message: Message) => {
    let blob: null | Blob | Blob[] = null
    let file: null | File = null
    let messageText: string = ''
    let filesType: null | string = null

    if (message.msg_strategy === 'MEDIA' && IsJsonString(message.payload)) {
      const parseString = JSON.parse(message.payload)
      messageText = parseString.text
      filesType = parseString.files.length == 2 ? parseString.files[1].type : parseString.files[0].type
    } else {
      messageText = message.payload
    }

    const allSelected = this.newMessage.communities.filter(el => el.status).length === userStore.communities.length
    const communities = allSelected ? [] : (this.newMessage?.communities?.filter(el => el.status).map(el => el.id) || [])

    try {
      const messageOp: MessageOp = {
        op: OperationType.CREATE_MESSAGE,
        sender: userStore.user.user_id,
        type: message.msg_strategy,
        payload: messageText,
        expiry: message.expiry?.toISOString(),
        guid: message.create_guid,
        id: message.id,
        communities: communities,
        allCommunities: allSelected ? 1 : undefined,
        labels: [this.newMessage.label]
      }
      
      if (this.newMessage.files) {
        if (this.newMessage.files.length == 2 && this.newMessage.files[1]?.type === FilesType.VIDEO) {
          blob = [this.newMessage.files[0].url, this.newMessage.files[1].url]
          messageOp.type = StrategyType.media
          messageOp.files = [{ type: FilesType.IMAGE }, { type: FilesType.VIDEO }]
        }

        else if (this.newMessage.files[0]?.type === FilesType.IMAGE) {
          blob = this.newMessage.files[0].url
          messageOp.files = [{ type: FilesType.IMAGE }]
          messageOp.type = StrategyType.media
        }

        else if (this.newMessage.files[0]?.type === FilesType.PDF) {
          blob = this.newMessage.files[0].url
          messageOp.type = StrategyType.media
          messageOp.files = [{ type: FilesType.PDF }]
        }
      }

      // messages.updateMessage(this.createMessageFromNewMessage(StatusType.OUTGOING, message.communities))
      message.status = StatusType.OUTGOING
      const createdId = await api.createMessage([messageOp], blob)
      if (createdId) {
        this.newMessage.id = createdId
        const messageDetailsRes = await api.getMessageDetails(createdId)
        await userStore.initInfo()
        if (messageDetailsRes.success) {
          const msgDetails = messageDetailsRes.data?.[0] as MessageDetails | undefined
          // messages.updateMessage(this.createMessageFromNewMessage(StatusType.SENT, message.communities, msgDetails.received, msgDetails.total))
          message.status = StatusType.SENT
          message.received = msgDetails?.received || 0
          message.total = msgDetails?.total || 0
        }

        this.clearFiles()
      }
      else {
        this.clearFiles()
        throw 'fail'
      }
     
    } catch (e) {
      console.log('error', e)
      if (userStore.user) {
        messages.updateMessage(this.createMessageFromNewMessage(StatusType.FAILED))
      }
    }
  }

  createMessageFromNewMessage = (status: StatusType, communities: number[] = [], received: number = 0, total: number = 1): Message => {
    let fileType = null
    
    if (this.newMessage.files) {
      if (this.newMessage.files.length == 2) {
        fileType = this.newMessage.files[1]?.url.type
      } else {
        fileType = this.newMessage.files[0]?.url.type
      }
    }

    return {
      author_name: userStore.user.given_name,
      create_guid: this.newMessage.guid,
      created: new Date(),
      fileType: fileType,
      id: this.newMessage.id,
      labels: [this.newMessage.label],
      msg_strategy: this.newMessage.strategyType,
      payload: this.newMessage.payload,
      expiry: this.newMessage.expiry,
      senderId: userStore.user.user_id,
      senderName: userStore.user.given_name,
      received: received,
      total: total,
      updated: new Date(),
      status: status,
      communities: communities
    }
  }
}

const newMessageStore = new NewMessageStore()
export default newMessageStore
